import { Sizes } from '../../constants/size';
import type { IconProps } from '../../types/icon-props';

export const NoResult = (props: IconProps) => {
  const { size = 'md', fill = 'var(--grey-1)', stroke = 'var(--grey-1)', ...rest } = props;

  return (
    <svg width="160" height="177" viewBox="0 0 160 177" xmlns="http://www.w3.org/2000/svg" {...rest}>
      <defs>
        <linearGradient x1="49.968%" y1="-2.316%" x2="49.968%" y2="101.076%" id="vvxwdn083c">
          <stop offset="0%" stopColor="#FDFEFF" />
          <stop offset="99.64%" stopColor="#ECF0F5" />
        </linearGradient>
        <filter
          x="-54.5%"
          y="-30%"
          width="209%"
          height="185.2%"
          filterUnits="objectBoundingBox"
          id="iitdrs0o4a"
        >
          <feOffset dy="14" in="SourceAlpha" result="shadowOffsetOuter1" />
          <feGaussianBlur stdDeviation="13.5" in="shadowOffsetOuter1" result="shadowBlurOuter1" />
          <feColorMatrix
            values="0 0 0 0 0.396078431 0 0 0 0 0.478431373 0 0 0 0 0.576470588 0 0 0 0.27 0"
            in="shadowBlurOuter1"
          />
        </filter>
        <path
          d="m104.985 36.308.984 79.261c0 2.708-2.215 4.8-4.923 4.8H23.754c-2.708 0-4.923-2.215-4.923-4.8V13.662c0-2.708 2.215-4.8 4.923-4.8h56l25.23 27.446z"
          id="maj33zd14b"
        />
      </defs>
      <g fill="none" fillRule="evenodd">
        <path d="M0 0h160v160H0z" />
        <g>
          <path
            d="M77.292 144.862c34.462 0 62.4-27.939 62.4-62.524 0-34.584-28.061-62.523-62.4-62.523-34.461 0-62.4 27.939-62.4 62.523 0 34.585 27.939 62.524 62.4 62.524zM135.63 41.354a5.046 5.046 0 1 0 .001-10.092 5.046 5.046 0 0 0 0 10.092zM143.015 21.662a3.446 3.446 0 1 0 0-6.892 3.446 3.446 0 0 0 0 6.892zM18.215 41.23a3.446 3.446 0 1 0 0-6.891 3.446 3.446 0 0 0 0 6.892z"
            fill="#EAEEF9"
          />
          <g transform="translate(14.77 14.77)">
            <use fill="#000" filter="url(#iitdrs0o4a)" xlinkHref="#maj33zd14b" />
            <use fill="url(#vvxwdn083c)" xlinkHref="#maj33zd14b" />
          </g>
          <path d="M21.17 144.492a6.4 6.4 0 1 0 0-12.8 6.4 6.4 0 0 0 0 12.8z" fill="#EAEEF9" />
          <path
            d="M71.262 119.262H68.43c-.616 0-1.108-.616-1.108-1.354 0-.739.492-1.354 1.108-1.354h2.83c.616 0 1.108.615 1.108 1.354 0 .861-.492 1.354-1.107 1.354z"
            fill="#CED7E2"
          />
          <path
            d="M62.646 119.262H46.154c-.616 0-1.108-.616-1.108-1.354 0-.739.492-1.354 1.108-1.354h16.492c.616 0 1.108.615 1.108 1.354 0 .861-.492 1.354-1.108 1.354zM83.692 40.246H46.646c-.861 0-1.6-.738-1.6-1.6 0-.861.739-1.6 1.6-1.6h37.046c.862 0 1.6.739 1.6 1.6 0 .862-.738 1.6-1.6 1.6zM60.923 49.108H46.646c-.861 0-1.6-.739-1.6-1.6 0-.862.739-1.6 1.6-1.6H60.8c.862 0 1.6.738 1.6 1.6 0 .861-.738 1.6-1.477 1.6zM94.523 23.63v21.908c0 3.077 2.708 5.539 5.785 5.539h19.446"
            fill="#D5DDEA"
          />
          <path
            d="M125.662 136.985c-1.231 0-2.462-.493-3.447-1.6l-20.553-20.554-.739.492c-6.646 4.923-14.4 7.508-22.277 7.508-9.477 0-18.954-3.816-25.97-10.462-7.384-7.015-11.445-16.492-11.445-26.83 0-20.554 16.738-37.293 37.292-37.293 14.03 0 26.339 7.385 32.985 19.939 6.523 12.43 5.661 26.953-2.339 38.646l-.492.738 20.677 20.677c2.092 2.092 1.6 4.185 1.23 5.292-.984 1.97-2.953 3.447-4.922 3.447zM78.523 58.462c-15.015 0-27.077 12.184-27.077 27.076 0 16.985 13.908 27.2 27.446 27.2 8.246 0 15.754-3.692 21.046-10.338 6.524-8.123 7.631-19.077 3.077-28.554-4.677-9.477-14.03-15.384-24.492-15.384z"
            fill="#989FB0"
          />
          <path
            d="M66.83 89.97c1.6 0 2.955-1.355 2.955-2.955s-1.354-2.953-2.954-2.953-2.954 1.353-2.954 2.953c0 1.6 1.354 2.954 2.954 2.954zM89.477 89.97c1.6 0 2.954-1.355 2.954-2.955s-1.354-2.953-2.954-2.953-2.954 1.353-2.954 2.953c0 1.723 1.354 2.954 2.954 2.954zM66.716 77.243l-6.498 3.508.877 1.624 6.498-3.509zM89.076 77.196l-.877 1.625 6.499 3.508.876-1.625zM78.154 96.862c1.904 0 3.446-1.157 3.446-2.585s-1.542-2.585-3.446-2.585c-1.903 0-3.446 1.157-3.446 2.585s1.543 2.585 3.446 2.585z"
            fill="#989FB0"
          />
        </g>
      </g>
    </svg>
  );
};

NoResult.displayName = 'NoResult';
